import api from "@/shared/services/apiClient";

export const commentService = {
  getComments: async (type: string, id: string | number) => {
    const response = await api.get(`/comments/${type}/${id}`);
    const raw = response.data;
    // Normalise: backend may return user_name instead of author_name
    if (Array.isArray(raw)) {
      return raw.map((c: any) => ({
        ...c,
        author_id: c.author_id || c.user_id || c.created_by || undefined,
        author_name: c.author_name || c.user_name || c.name || undefined,
        author_profile_pic_id: c.author_profile_pic_id || c.profile_pic_id || c.pic_id || undefined,
      }));
    }
    return raw;
  },

  addComment: async (data: any) => {
    const payload = {
      ...data,
      parent_comment_id: data.parent_comment_id || null,
      metadata: data.metadata || {},
    };
    const response = await api.post("/comments", payload);
    return response.data;
  },

  updateComment: async (commentId: string | number, text: string) => {
    const response = await api.put(`/comments/${commentId}`, {
      content_text: text,
    });
    return response.data;
  },

  deleteComment: async (commentId: string | number) => {
    const response = await api.delete(`/comments/${commentId}`);
    return response.data;
  },
};
